<template src="./html/Datatable.html"></template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import Actions from './Actions'
	import VueElementLoading from 'vue-element-loading'
	import ChangeStatus from './ChangeStatus'
	import _ from 'lodash'

	export default {
		props: ['user', 'isAuth', 'order'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'loading': VueElementLoading,
			'actions': Actions,
			'change-status': ChangeStatus,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/delivery/notes/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
							order_id: null
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:order',
							title: 'Pedido',
						},
						{
							name: '__slot:base_amount',
							title: 'Precio',
							sortField: 'base_amount',
						},
						{
							name: '__slot:taxes',
							title: 'Impuestos',
							sortField: 'taxes',
						},
						{
							name: '__slot:amount',
							title: 'Base imponible',
							sortField: 'amount',
						},
						{
							name: '__slot:total',
							title: 'Total',
							sortField: 'total',
						},
						{
							name: '__slot:status',
							title: 'Estado',
						},
						{
							name: '__slot:author',
							title: 'Autor',
						},
						{
							name: 'created_at',
							title: 'Fecha emisión',
							callback: function(value) {
								return moment(value).format('DD/MM/YY')
							},
							sortField: 'created_at',
						},
						{
							name: 'delivery_date',
							title: 'Fecha entrega',
							callback: function(value) {
								if(value) {
									return moment(value).format('DD/MM/YY')
								}
							},
							sortField: 'created_at',
						},
						{
							name: '__slot:actions',
							title: '',
						}
					],
				},
			}
		},
		created() {
			this.init()
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		methods: {
			init() {
				if(this.order) {
					this.datatable.moreParams.filter.order_id = this.order.id
				}
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.normalizeFields())
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset() {
				this.clearFilter()
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
				this.$router.replace({'query': null})
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			destroy(delivery_note) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/delivery/notes/' + delivery_note.id)
							.then(response => {
								that.reload()
								that.$emit('reload')
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								console.log(response)
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type)
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/deliveryNotes/views/Datatable.vue